<tt-page *ngIf="!!setting">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="filter"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <ng-container *ngTemplateOutlet="list"></ng-container>

        <tt-card>
            <ng-container *ngTemplateOutlet="btnSettings"></ng-container>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-2 p-5">
                <ng-container *ngTemplateOutlet="filter"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <ng-container *ngTemplateOutlet="btnSettings"></ng-container>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>
    </div>
</tt-page>

<ng-template #filter>
    <ng-container *ngIf="!!setting">
        <tt-input ttRememberId="w_deliverymethods.filterval" ttLabel="filterval" ttFocus="true" [(ttModel)]="setting.filterval" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto [ttText]="'add'" (ttClick)="goToFunc('deliverymethod')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!setting">
        <tt-list [ttData]="itemsListDeliveryMethods" [ttFilter]="setting.filterval"></tt-list>
    </ng-container>
</ng-template>

<ng-template #btnSettings>
    <ng-container *ngIf="!!setting">
        <tt-button-settings></tt-button-settings>
    </ng-container>
</ng-template>


<!--<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === false">
    <tt-card class="col-xs-12 sp-0">
        <tt-input-buttons class="col-xs-12 sp-0" tt-label="filterval" tt-focus="false" tt-model="vm.model.setting.filterval" tt-on-blur="vm.onBlur('filterval')" tt-change="vm.onChanged($value, 'filterval')" tt-placeholder="" tt-buttons="vm.model.filterValueButtons" tt-readonly="false"></tt-input-buttons>
        <tt-button class="col-xs-12 sp-0" tt-text="add" tt-click="vm.goToFunc('deliverymethod')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <im-list-directive class="col-xs-12 sp-0" list-items="vm.model.itemsListDeliveryMethods" badge="" ltype="" design-var="s12t0" filter-val="vm.model.setting.filterval"></im-list-directive>

    <tt-card class="col-xs-12 sp-0">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>-->
